import { render, staticRenderFns } from "./GeneralSettingsCheckoutShowDeliveryTime.vue?vue&type=template&id=3b1ac122&"
import script from "./GeneralSettingsCheckoutShowDeliveryTime.vue?vue&type=script&lang=ts&"
export * from "./GeneralSettingsCheckoutShowDeliveryTime.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports